import { baseApiRequest } from "../baseApiRequest"

const origin = process.env.REACT_APP_API_ORIGIN ?? ''

export async function unauthedMutationFunction<TResponse, TRequestBody>(
  body: TRequestBody,
  method: 'POST' | 'PUT' | 'DELETE',
  path: string,
) {
  const url = `${origin}/api/${path}`

  return baseApiRequest<TResponse>({
    url,
    init: {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: body ? JSON.stringify(body) : undefined,
    },
    trackingEvent: 'useUnauthedApiMutation',
  })
}
